<template>
    <div class="flag-selector">
      <div class="header">
        <!-- <h1>下月学习Flag选择</h1> -->
         <P class="font1">逐梦前行，点亮成长</P>
         <P class="font1">开启你的季度学习FLAG！</P>
         <!-- <P class="font1">让我们坚定信念，勇敢追梦！</P> -->
      </div>
      
      <div class="goals-container">
        <div class="goal-row" v-for="(row, rowIndex) in goalRows" :key="rowIndex">
          <div class="goal-wrapper" :style="getAnimationStyle(rowIndex)">
            <div class="goal" v-for="(goal, index) in row.goals" :key="`${rowIndex}-${index}`" :data-id="goal.id" :class="{ selected: isSelected(goal.id) }" @click="toggleGoal(goal.id)">
              <div class="goal-icon">{{ goal.emoji }}</div>
              <div class="goal-text">{{ goal.text }}</div>
              <div class="check-icon">✓</div>
            </div>
            <!-- 复制元素以实现无缝滚动 -->
            <div class="goal" v-for="(goal, index) in row.goals" :key="`${rowIndex}-${index}-copy`" :data-id="goal.id" :class="{ selected: isSelected(goal.id) }" @click="toggleGoal(goal.id)">
              <div class="goal-icon">{{ goal.emoji }}</div>
              <div class="goal-text">{{ goal.text }}</div>
              <div class="check-icon">✓</div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="footer">
        <button class="confirm-btn" :disabled="selectedGoals.length === 0" @click="confirmSelection">确认选择</button>
      </div>
    </div>
</template>
  
<script>
export default {
    name: 'FlagSelector',
    data() {
        return {
            selectedGoals: [],
            goalRows: [
                {
                    goals: [
                        { id: '1', emoji: '⏳', text: '时间掌控在手，高效人生由你决定！' },
                        { id: '2', emoji: '🎯', text: '设定清晰目标，一步步迈向成功！' }
                    ]
                },
                {
                    goals: [
                        { id: '3', emoji: '💻', text: '玩转办公软件，让效率飞跃提升！' },
                        { id: '4', emoji: '📊', text: '用数据说话，让分析更有洞察力！' }
                    ]
                },
                {
                    goals: [
                        { id: '5', emoji: '🤝', text: '掌握谈判技巧，赢得更多职场优势！' },
                        { id: '6', emoji: '🌍', text: '拓展全球视野，让沟通无国界！' }
                    ]
                },
                {
                    goals: [
                        { id: '7', emoji: '📊', text: '数据驱动决策，掌握未来核心竞争力！' },
                        { id: '8', emoji: '🏭', text: '工业智能化，引领制造新趋势！' }
                    ]
                },
                {
                    goals: [
                        { id: '9', emoji: '💙', text: '释放压力，保持心理韧性！' },
                        { id: '10', emoji: '🚑', text: '关键时刻，学会自救，守护生命！' }
                    ]
                },
                {
                    goals: [
                        { id: '11', emoji: '🔋', text: '低碳生活，共建可持续未来！' },
                        { id: '12', emoji: '🌏', text: '跟上时代步伐，拥抱绿色未来！' }
                    ]
                },
                {
                    goals: [
                        { id: '13', emoji: '📜', text: '合规经营，企业可持续发展！' },
                        { id: '14', emoji: '🧑‍💻', text: '尊重创造，保护创新成果！' }
                    ]
                }
            ]
        }
    },
    methods: {
        toggleGoal(goalId) {
            const index = this.selectedGoals.indexOf(goalId);
            
            if (index === -1 && this.selectedGoals.length < 3) {
                this.selectedGoals.push(goalId);
            } else if (index !== -1) {
                this.selectedGoals.splice(index, 1);
            } else {
                alert('最多可选3个目标哦！');
            }
        },
        isSelected(goalId) {
            return this.selectedGoals.includes(goalId);
        },
        confirmSelection() {
            if (this.selectedGoals.length === 0) {
                this.$message({
                    message: '请至少选择一个目标！',
                    type: 'warning',
                    center: true
                })
                return;
            }

            // 获取选择的目标文本
            const selectedGoalTexts = this.selectedGoals.map(goalId => {
                for (const row of this.goalRows) {
                    const foundGoal = row.goals.find(goal => goal.id === goalId);
                    if (foundGoal) return foundGoal.text;
                }
                return null;
            }).filter(text => text !== null); // 过滤掉 null，确保数据干净

            const view = {
                comment: selectedGoalTexts.join(', '),
                // studyList: this.studyList
            }
            this.$emit('confirmSelection',view)
            // console.log(selectedGoalTexts);
            // alert('目标提交成功！你选择了：' + selectedGoalTexts.join(', '));
        },
        getAnimationStyle(rowIndex) {
            // 为每行设置不同的动画延迟
            const delay = rowIndex * 1000;
            return {
                animationDelay: `${delay}ms`
            };
        }
    }
}
</script>
  
<style scoped>
.flag-selector {
    background: 
                url("../../assets/25March/logo.png") right  top  no-repeat,
                url("../../assets/25May/bg.jpg")  no-repeat;
    background-size: 100% 100%,cover;
    width: 100%;
    height: 100vh;
    padding-top: 1px;
}
  
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: Arial, sans-serif;
}
  
.header {
    text-align: center;
    margin-top: 8vh;
    margin-bottom: 2vh;
}

.font1 {
    width: 96%;
    margin: 0 auto;
    font-size: 20px;
    text-align: center·;
    color: #26a5e1;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.header h1 {
    font-size: 19px;
    color: #333;
}

.goals-container {
    max-width: 600px;
    margin: 0 auto;
}

.goal-row {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
    overflow: hidden;
    position: relative;
    height: 40px;
}

.goal-wrapper {
    display: flex;
    animation: scrollGoals 30s linear infinite;
    animation-fill-mode: forwards;; 
}

.goal {
    background-color: #fff;
    border-radius: 20px;
    padding: 8px 15px;
    margin: 0 5px;
    display: flex;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    transition: all 0.2s;
    /* min-width: 120px; */
}
  
.goal:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}
  
.goal.selected {
    background-color: #e6f7ff;
    color: #1890ff;
}
  
.goal-icon {
    margin-right: 8px;
    font-size: 19px;
}

.goal-text {
    flex: 1;
    font-size: 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
  
.check-icon {
    display: none;
    margin-left: 8px;
    font-size: 16px;
}

.goal.selected .check-icon {
    display: block;
}
  
.footer {
    text-align: center;
    margin-top: 20px;
}
  
.confirm-btn {
    background-color: #1890ff;
    color: white;
    border: none;
    border-radius: 20px;
    padding: 10px 25px;
    font-size: 16px;
    cursor: pointer;
}
  
.confirm-btn:disabled {
    background-color: #bbb;
    cursor: not-allowed;
}
  
@keyframes scrollGoals {
    0% {
        transform: translateX(50%);
    }
    100% {
        transform: translateX(-50%);
    }
}
</style>